import React from "react";
import SectionOne from "./components/section/SectionOne";
import SectionTwo from "./components/section/SectionTwo";
import SectionThree from "./components/section/SectionThree";

function App() {
  return (
    <>
    <SectionOne/>
    <SectionTwo/>
    <SectionThree/>
    </>
  );
}

export default App;
